import {
  CommonRenderCellProps,
  CommonTableTemplate,
} from 'app/common/templates-next/table-template'
import { Td } from 'app/common/ui-components/table'

import styles from '../SurveysTable.module.scss'
import { SurveyScopeValues } from './cellContent/SurveyScopeValues'
import { SurveyActions } from './cellContent/SurveyActions'
import { SurveysTableColumn, SurveysTableDataItem } from './surveysTableProps'
import { SurveysTablePeriod } from './cellContent/SurveysTablePeriod'
import { SurveysTableResults } from './cellContent/SurveysTableResults'
import { SurveysTableTitle } from './cellContent/SurveysTableTitle'

const scopeFields = {
  [SurveysTableColumn.Settlement]: { field: 'cities', header: 'Населенные пункты' },
  [SurveysTableColumn.District]: { field: 'districts', header: 'Районы' },
  [SurveysTableColumn.Institution]: { field: 'schools', header: 'Заведения' },
} as const

export const surveysTableRenderCell = (
  params: CommonRenderCellProps<SurveysTableDataItem, SurveysTableColumn>,
  archived = false,
  onSuccess: () => void = () => {},
) => {
  const { columnKey, rowData, cellProps } = params

  if (columnKey === SurveysTableColumn.Actions) {
    return (
      <Td {...cellProps}>
        <div className={styles.actionsContent}>
          <SurveyActions survey={rowData.survey} archived={archived} onSuccess={onSuccess} />
        </div>
      </Td>
    )
  }
  if (columnKey === SurveysTableColumn.KindLocation) {
    return (
      <Td {...cellProps}>
        <div>{rowData.survey.surveyKindLabel || '—'}</div>
        <div className={styles.muted}>{rowData.survey.surveyLocationLabel || '—'}</div>
      </Td>
    )
  }
  if (columnKey in scopeFields) {
    const { field, header } = scopeFields[columnKey as keyof typeof scopeFields]
    return (
      <Td {...cellProps}>
        <SurveyScopeValues
          survey={rowData.survey}
          field={field}
          header={header}
          fallback={rowData[columnKey]}
        />
        {field === 'cities' && rowData.survey.schoolTypeShortLabel && (
          <div className={styles.muted}>{`(${rowData.survey.schoolTypeShortLabel})`}</div>
        )}
      </Td>
    )
  }

  if (columnKey === SurveysTableColumn.Title) {
    return (
      <Td {...cellProps}>
        <SurveysTableTitle surveyId={rowData.id} title={rowData[columnKey]} />
      </Td>
    )
  }

  if (columnKey === SurveysTableColumn.Period) {
    return (
      <Td {...cellProps}>
        <SurveysTablePeriod dateFrom={rowData.dateFrom} dateTo={rowData.dateTo} />
      </Td>
    )
  }

  if (columnKey === SurveysTableColumn.Results) {
    return (
      <Td {...cellProps}>
        <SurveysTableResults positive={rowData.positive} negative={rowData.negative} />
      </Td>
    )
  }

  return CommonTableTemplate.defaultRenderCell(params)
}
